// extracted by mini-css-extract-plugin
export default {"container":"vr-z","brandName":"wr-z","productName":"xr-z","productNamePdpEnhancements":"yr-z","breakLongProductName":"zr-z"};